import React, { useEffect, useState, useRef, useContext } from "react";
import "./ExteriorInterior.css";

import exterior1 from "../../../../assets/images/mhero2/exterior/ext1.jpg";
import exterior2 from "../../../../assets/images/mhero2/exterior/ext2.png";
import exterior3 from "../../../../assets/images/mhero2/exterior/ext3.png";
import exterior4 from "../../../../assets/images/mhero2/exterior/ext4.png";
import exterior5 from "../../../../assets/images/mhero2/exterior/ext5.png";
import exterior6 from "../../../../assets/images/mhero2/exterior/ext6.png";
import exterior7 from "../../../../assets/images/mhero2/exterior/ext7.jpg";
import exterior8 from "../../../../assets/images/mhero2/exterior/ext8.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const sortByImageNumber = (a, b) => {
  const numA = Number((a.match(/\((\d+)\)/) || [])[1] || 0);
  const numB = Number((b.match(/\((\d+)\)/) || [])[1] || 0);
  return numA - numB;
};

const loadImagesFromFolder = (context) =>
  context
    .keys()
    .sort(sortByImageNumber)
    .map(context);

const interiorContext = require.context(
  "../../../../assets/images/mhero2/interior",
  false,
  /\.webp$/i
);

const accessoriesContext = require.context(
  "../../../../assets/images/mhero2/accessories",
  false,
  /\.webp$/i
);

const EXTERIOR_IMAGES = [
  exterior1,
  exterior2,
  exterior3,
  exterior4,
  exterior5,
  exterior6,
  exterior7,
  exterior8,
];
const INTERIOR_IMAGES = loadImagesFromFolder(interiorContext);
const ACCESSORIES_IMAGES = loadImagesFromFolder(accessoriesContext);

const Slider = ({ title, images }) => {
  const [index, setIndex] = useState(0);

  const startX = useRef(null);
  const isDragging = useRef(false);
  const threshold = 60;

  if (!images || images.length === 0) return null;

  const prev = () =>
    setIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );

  const next = () =>
    setIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (!startX.current) return;

    const endX = e.changedTouches[0].clientX;
    const diff = startX.current - endX;

    if (diff > threshold) next();
    if (diff < -threshold) prev();

    startX.current = null;
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.clientX;
  };

  const handleMouseUp = (e) => {
    if (!isDragging.current) return;

    const endX = e.clientX;
    const diff = startX.current - endX;

    if (diff > threshold) next();
    if (diff < -threshold) prev();

    isDragging.current = false;
    startX.current = null;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
    startX.current = null;
  };

  return (
    <section className="gallery-section">
      <h2 className="gallery-title">{title}</h2>
      <span className="gallery-line" />

      <div
        className="slider"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={images[index]}
          alt={title}
          className="slide-image"
          draggable="false"
        />

        <button className="arrow left" onClick={prev}>
          ‹
        </button>
        <button className="arrow right" onClick={next}>
          ›
        </button>

        <div className="dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const ExteriorInterior = () => {
  const { currentLang } = useContext(LanguageContext);

  const [titles, setTitles] = useState({
    exterior_title: "Exterior",
    interior_title: "Interior",
    accessories_title: "Accessories",
  });

  useEffect(() => {
    const loadGalleryText = async () => {
      try {
        const response = await getPageContent("mhero2", currentLang);
        const gallery = response.sections?.gallery;

        if (gallery) {
          setTitles({
            exterior_title: gallery.exterior_title || "Exterior",
            interior_title: gallery.interior_title || "Interior",
            accessories_title: gallery.accessories_title || "Accessories",
          });
        }
      } catch (err) {
        console.error("Failed to load MHERO2 gallery text", err);
      }
    };

    loadGalleryText();
  }, [currentLang]);

  return (
    <div className="gallery-wrapper" dir="ltr">
      <Slider title={titles.exterior_title} images={EXTERIOR_IMAGES} />
      <Slider title={titles.interior_title} images={INTERIOR_IMAGES} />
      <Slider title={titles.accessories_title} images={ACCESSORIES_IMAGES} />
    </div>
  );
};

export default ExteriorInterior;
